import axios from "axios";

export const formatDatasource = (datasource: any) => {
	if (!datasource) return [];
	const formattedDatasource = datasource.map((item: any) => {
		if (item.dimension_value) {
			return {
				name: item.name,
				value: item.dimension_value,
			};
		}

		return {
			name: item.name,
			value: item.value,
		};
	});
	return formattedDatasource;
};

export const getDatasource = async (datasource: string, locale?: string) => {
	const res = await axios.get(
		`https://api.storyblok.com/v2/cdn/datasource_entries?datasource_slug=${datasource}&token=hXGDiZ4BsL9gh4Mz3J17rAtt&dimension=${locale}`,
		{
			headers: {
				Authorization: "Bearer ZLwOrhBM0BaYKXfQ31zl5Att-116043-wrZ8m79o_KgzoxNeeTBn",
			},
		},
	);

	const data = formatDatasource(res?.data?.datasource_entries);

	return data;
};
